import styled from 'styled-components';
import { COLORS } from '../../../../theme';

export const Wrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.h6};
  color: ${COLORS.black90};
  padding: ${({ theme }) => theme.spacing.s1} ${({ theme }) => theme.spacing.s2};
  background: ${COLORS.black10};
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;
